




















import {Component, Vue} from "vue-property-decorator";
import FaqTitle from "@/components/details/FaqTitle.vue";
import FaqcContent from "@/components/details/FaqContent.vue";

@Component({
    components: {
        FaqTitle,
        FaqcContent
    }
})
export default class Details extends Vue{
    private ltype:string = '0';
    private faqId:string = '0'
    private faqItem:any = {};

    private loadJson(): void{
        const PRENAME:string = 'faq-list-';

        var jsonData = require('../assets/json-data/faq-list-' + (parseInt(this.ltype) + 1) + '.json');

        this.faqItem = jsonData.items[this.faqId];
    }

    mounted () {
        this.ltype = this.$route.params.type;
        this.faqId = this.$route.params.id;

        this.loadJson();
    }
}
